import React from 'react';
import styled from 'styled-components';
import { Grid, ONE_COLUMN_MAX_WIDTH, TWO_COLUMN_MAX_WIDTH } from '../Grid';
import { GalleryMenuContextProvider, useGalleryMenuContext, } from './GalleryMenuProvider';
import { cssColorValue, spacer24, Text, } from '@spotify-internal/encore-web/core';
import { ActiveLinkImage } from './ActiveLinkImage';
const StyledGrid = styled(Grid) `
  padding-bottom: ${spacer24};
  color: ${cssColorValue('textBase')};
  grid-row-gap: 32px;
  & > * {
    grid-column-start: span 3;
  }
  .image {
    grid-column-start: span 6;
    grid-row-start: span 2;
  }
  .description {
    grid-column-start: span 4;
    display: flex;
    align-items: flex-end;
  }

  @media (max-width: 1429px) {
    .description {
      grid-column-start: span 5;
    }
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-row-gap: 40px;
    & > * {
      grid-column-start: span 2;
    }
    .image,
    .description {
      display: none;
    }
  }

  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    grid-column-gap: 0px;
    padding-bottom: 52px;
  }
`;
const ActiveLinkDescription = ({ className }) => {
    const { activeGalleryLink } = useGalleryMenuContext();
    return (React.createElement(Text, { variant: "bodyMedium", className: className }, activeGalleryLink === null || activeGalleryLink === void 0 ? void 0 : activeGalleryLink.description));
};
export const GalleryMenu = ({ column1, column2, defaultActiveLink, allLinks, }) => {
    return (React.createElement(GalleryMenuContextProvider, { defaultActiveLink: defaultActiveLink, allLinks: allLinks },
        React.createElement(StyledGrid, null,
            column1,
            column2,
            React.createElement(ActiveLinkImage, { className: "image" }),
            React.createElement(ActiveLinkDescription, { className: "description" }))));
};
//# sourceMappingURL=index.js.map